<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 3 :</span>
          ประเด็นปัญหาและความต้องการ
          <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
        </div>

        <div class="theme-color-eight mb-3">
          โปรดเรียงลำดับความสำคัญ 1 2 3 ... ตามประเด็นความต้องการเร่งด่วน
        </div>

        <!-- Form 1 -->
        <div class="checkbox-list mb-3">
          <CheckBox
            v-for="(item, i) in masterData.topics"
            :key="i"
            :value="item.name"
            :input-value="form.p3_issue_and_req"
            @onChange="setCheckboxField('p3_issue_and_req', item.name)"
            >{{ item.name }}</CheckBox
          >
        </div>

        <div class="d-flex align-center">
          <CheckBox
            value="อื่น ๆ โปรดระบุ"
            :input-value="form.p3_issue_and_req"
            @onChange="
              setCheckboxField('p3_issue_and_req', 'อื่น ๆ โปรดระบุ');
              form.p3_req_other = '';
            "
          ></CheckBox>
          <div
            class="flex-center gap-12"
            style="min-width: 550px; max-width: 550px"
          >
            <div class="text-no-wrap">อื่น ๆ โปรดระบุ</div>
            <TextField
              :disabled="
                form.p3_issue_and_req &&
                !form.p3_issue_and_req.includes('อื่น ๆ โปรดระบุ')
              "
              theme="3"
              hide-details
              :value="form.p3_req_other"
              @onChange="setFormField('p3_req_other', $event)"
            ></TextField>
          </div>
        </div>
      </div>

      <div class="card-part">
        <!-- Form 2 -->
        <div>
          <div class="d-flex align-center justify-space-between mb-3">
            <div class="black--text txt-head">ลงนามผู้กรอกข้อมูล</div>
            <Button theme="5" @onClick="clearSignature">ลบ</Button>
          </div>
          <v-img
            v-if="imageURL"
            style="position: absolute"
            width="96%"
            height="150px"
            :src="imageURL"
          />
          <VueSignaturePad
            ref="signaturePad"
            height="150px"
            class="field-theme"
          />
        </div>
      </div>

      <div class="card-part">
        <!-- Form 3 -->
        <div>
          <CheckBox class="mb-4" max-width="100%">
            <div>
              ข้าพเจ้าให้ความยินยอมในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูล
              เพื่อประโยชน์ต่อกระบวนการขอรับบริการหรือองค์ความรู้จากกระทรวงการอุดมศึกษา
              วิทยาศาสตร์ วิจัยและนวัตกรรม
            </div>
          </CheckBox>

          <CheckBox max-width="100%">
            <div>ข้าพเจ้าขอรับรองว่าข้อมูลทั้งหมดเป็นความจริงทุกประการ</div>
          </CheckBox>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../components/input/TextField";
import CheckBox from "../../components/input/CheckBox";
import Button from "../../components/input/Button";
import { mapState } from "vuex";
import { eventBus } from "../../plugins/global-funcs";
import { apiDomain } from "@/store/constants";

export default {
  name: "FormIssuesAndNeeds",
  components: {
    TextField,
    CheckBox,
    Button,
  },
  props: {
    masterData: Object,
    formData: Object,
  },
  data() {
    return {
      topics: [],
      form: {},
      otherTopic: false,
      imageURL: "",
    };
  },
  watch: {
    formData: {
      handler(newValue) {
        this.form = JSON.parse(JSON.stringify(newValue));

        if (this.form.p3_signature) {
          this.imageURL = apiDomain + "storage/" + this.form.p3_signature;
          console.log(this.imageURL);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      IssuesAndNeedsForm: (state) => state.Requirement.IssuesAndNeedsForm,
    }),
  },
  created() {
    this.form = JSON.parse(JSON.stringify(this.formData));
    eventBus.$on("requirementFormIssuesAndNeeds", () => {
      this.form.p3_signature = this.getSignature();
      eventBus.$emit("requirementFormIssuesAndNeedsSend", this.form);
    });
    eventBus.$emit("requirementFormGeneralSend", this.form);

    console.log("p3_issue_and_req", this.form.p3_issue_and_req);
  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
    setCheckboxField(fieldName, value) {
      console.log(!Array.isArray(this.form[fieldName]));
      //check this.form[fieldName] is array
      if (!Array.isArray(this.form[fieldName])) {
        //convert to array
        this.form[fieldName] = [this.form[fieldName]];
      }
      const index = this.form[fieldName].indexOf(value);
      if (index === -1) {
        this.form[fieldName].push(value);
      } else {
        this.form[fieldName].splice(index, 1);
      }
      // If the array is empty, delete the key from the object
      if (this.form[fieldName].length === 0) {
        delete this.form[fieldName];
      }
      console.log(this.form[fieldName]);
    },
    clearSignature() {
      this.form.p3_signature = "";
      this.imageURL = "";
      this.$refs.signaturePad.clearSignature();
    },
    getSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.log(data);
      if (isEmpty) return undefined;
      return data;
    },
  },
};
</script>

<style scoped lang="scss">
.checkbox-list {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 4;
  --grid-item--min-width: 100px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc(
    (100% - var(--total-gap-width)) / var(--grid-column-count)
  );

  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap: var(--grid-layout-gap);
}

.field-theme {
  border-radius: 20px;
  border: solid 1px var(--theme-color-eight);
}
</style>
